<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <circle cx="12" cy="12" r="4"></circle>
    <circle cx="18" cy="6" r="1" fill="currentColor" stroke="none"></circle>
  </svg>
</template>
